
//import CheckmarkIcon from "../assets/img/checkmark.svg"; // Copy/Pasted SVG directly for now
import { Color, TextColor } from "@Beasted1010/pivotal-wisdom";

import { AccountModal } from "../common/UserComponents";



function PreOrder() {
  return (
    <div className="platform-course_pre-order">
      Pre-Order
    </div>
  );
}

function Ellipses() {
  return (
    <div className="ellipses">...</div>
  );
}

function MoreToCome() {

  // TODO: Make different background, something subtle, and OBVIOUS not a "Subject" (so user not try hover)
  // --- Consider? Neat format where "More" on first line, "to" on second, and "Come!" Curved a bit like a smile/curved-arrow-head
  return (
    <div className="more-to-come">
      <Ellipses />
      <h3>More to Come!</h3>
    </div>
  );
}



function Notice( { content }: INotice ) {

  return (
    <div className="notice_container">
      <span className="notice_symbol"></span>
      <span className="notice_text">{content}</span>
    </div>
  );
}


function HamburgerMenu() {
  return (
    <div className="hamburger-menu">
      <div className="hamburger-menu_bar"></div>
      <div className="hamburger-menu_bar"></div>
      <div className="hamburger-menu_bar"></div>
    </div>
  );
}


function Checkmark( {color}: {color: Color} ) {
  const fillColor = TextColor[color];

  return (
    <svg className={ `checkmark ${fillColor}` }
         data-cacheid="b0e3a8d604fc4236a439ee2870118895"
         id="e1CH8DuhxMg1"
         xmlns="http://www.w3.org/2000/svg"
         xmlnsXlink="http://www.w3.org/1999/xlink"
         viewBox="0 0 300 300"
         shapeRendering="geometricPrecision"
         textRendering="geometricPrecision">
      <g transform="matrix(5.100773 0 0 5.100773-512.40732-619.57753)">
        <rect width="68.077803"
              height="5.263158"
              rx="0"
              ry="0"
              transform="matrix(.468963-.650969 1.217066 0.876784 119.793742 170.72563)"
              fill="currentColor"
              strokeWidth="0"/>
        <rect width="68.077803"
              height="5.263158"
              rx="0"
              ry="0"
              transform="matrix(.267117 0.192795-.877869 1.216283 106.247171 151.199056)"
              fill="currentColor"
              strokeWidth="0"/>
      </g>
    </svg>
  );
}


function FeatureComingSoon() {
  return (
    <h1 className="feature-coming-soon">
      Coming Soon
    </h1>
  );
}
function FeatureComingSoonMobile() {
  return (
    <h1 className="feature-coming-soon_mobile">
      Coming Soon
    </h1>
  );
}




// TODO: Apply "fillColor" like do in Checkmark above so that this is customized per theme
function LockIcon( {size="64", cssClassName=""}: {size?: string, cssClassName?: string} ) {
  return (
    <svg className={cssClassName}
      stroke="currentColor" 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 32 32" 
      fill="currentColor" 
      width={size}
      height={size} >
      <path 
        d="M24.21 13H24V9A8 8 0 0 0 8 9v4h-.21A2.79 2.79 0 0 0 5 15.79v12.42A2.79 2.79 0 0 0 7.79 31h16.42A2.79 2.79 0 0 0 27 28.21V15.79A2.79 2.79 0 0 0 24.21 13ZM10 9a6 6 0 0 1 12 0v4H10Zm15 19.21a.79.79 0 0 1-.79.79H7.79a.79.79 0 0 1-.79-.79V15.79a.79.79 0 0 1 .79-.79h16.42a.79.79 0 0 1 .79.79Z">
      </path>
    </svg>
  );
}
function GeneralLockedContentContainer( {HeaderComponent, alert, description}: {HeaderComponent?: any, alert: string, description: string} ) {
  return (
    // TODO: CHANGE CSS CLASSES TO BE MORE APPROPRIATE (or more general...?)
    <div className="log-in-prompt_container">
      { HeaderComponent ? <HeaderComponent /> : <></> }
      <h2 className="log-in-prompt_heading">
        <span className="general-locked-content_alert">{alert}.</span>
      </h2>

      <p className="log-in-prompt_body">
        {description}
      </p>
    </div>
  );
}
function LogInPromptContainer( {HeaderComponent, logInTo, description}: {HeaderComponent?: any, logInTo: string, description: string} ) {
  return (
    <div className="log-in-prompt_container">
      { HeaderComponent ? <HeaderComponent /> : <></> }
      <h2 className="log-in-prompt_heading">
        <span className="log-in_button">Log In</span> to {logInTo}.
        <AccountModal />
      </h2>

      <p className="log-in-prompt_body">
        {description}
      </p>
    </div>
  );
}


export {
  PreOrder,
  Ellipses,
  MoreToCome,
  Notice,
  HamburgerMenu,
  Checkmark,
  FeatureComingSoon, FeatureComingSoonMobile,

  LockIcon,
  GeneralLockedContentContainer,
  LogInPromptContainer,
};
